import { render, staticRenderFns } from "./ScreenGuias.vue?vue&type=template&id=6f9da9f5"
import script from "./ScreenGuias.vue?vue&type=script&lang=js"
export * from "./ScreenGuias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports